const PENDING_STATUS = 1
const ANSWERED_STATUS = 2
const INACTIVE_STATUS = 3

const AFFIRMATIVE_ANSWER = 'Sim'
const NEGATIVE_ANSWER = 'Não'
const NOT_APPLICABLE_ANSWER = 'Não se aplica'
const PARTIAL_ANSWER = 'Parcial'

const ALL_TAB = 'all'
const PENDING_TAB = 'pending'
const ANSWERED_TAB = 'answered'
const TABS = [
  {
    value: ALL_TAB,
    label: 'Todas',
  },
  {
    value: PENDING_TAB,
    label: 'Pendentes',
  },
  {
    value: ANSWERED_TAB,
    label: 'Respondidas',
  },
]
const TAB_VALUES = [ALL_TAB, PENDING_TAB, ANSWERED_TAB]

const GOOD_RATING = 'good'
const BAD_RATING = 'bad'

const questions = {
  AFFIRMATIVE_ANSWER,
  NEGATIVE_ANSWER,
  NOT_APPLICABLE_ANSWER,
  PENDING_STATUS,
  ANSWERED_STATUS,
  INACTIVE_STATUS,
  TABS,
  TAB_VALUES,
  ALL_TAB,
  PENDING_TAB,
  ANSWERED_TAB,
  PARTIAL_ANSWER,
  GOOD_RATING,
  BAD_RATING,
}

export default questions
